<template>
  <li :class="to ? 'link' : 'title'">
    <nav-link v-if="to" v-bind:to="to" @click="$emit('beforeNav')">
      <icon v-if="icon" :name="icon" />
      {{ title }}
    </nav-link>
    <span v-if="!to">{{ title }}</span>
  </li>
</template>
<script>
import NavLink from "./NavLink.vue";

export default {
  components: { NavLink },
  props: ["to", "icon", "title"],
  emits: ["beforeNav"],
};
</script>
